import $ from "jquery";

const contentAccordions = () => {
  const init = () => {
    accordion();
  };

  const accordion = () => {
    const el = {
      accordion: ".accordion",
    };

    if ($(el.accordion).length === 0) return;

    $(el.accordion).each((index, accordion) => {
      const minusIcons = $(accordion).find(".minus-icon");
      minusIcons.addClass("hidden");

      $(accordion).on("click", (e) => {
        const parentId = $(accordion).attr("id");
        if ($(e.target).data("parent") === parentId) {
          let btnContainer = [];
          let contentContainer = [];
          let plusIcon;
          let minusIcon;

          $(accordion)
            .children()
            .each((index, accItem) => {
              const accBtn = $(accItem).find(".accordion-button")[0];
              const accCont = $(accItem).find(".accordion-content")[0];

              btnContainer.push(accBtn);
              contentContainer.push(accCont);

              if ($(e.target).is(accBtn)) {
                plusIcon = $(accBtn).find(".plus-icon");
                minusIcon = $(accBtn).find(".minus-icon");
              }
            });

          if (
            $(e.target).hasClass("accordion-button") &&
            $(e.target).hasClass("active")
          ) {
            plusIcon.toggleClass("hidden", false);
            minusIcon.toggleClass("hidden", true);
            $(contentContainer).addClass("hide");
            $(btnContainer).removeClass("active");
          } else if ($(e.target).hasClass("accordion-button")) {
            $(contentContainer).addClass("hide");
            plusIcon.toggleClass("hidden", false);
            minusIcon.toggleClass("hidden", false);
            $(btnContainer).removeClass("active");
            $(e.target).next(".accordion-content").toggleClass("hide");
            $(e.target).toggleClass("active");
          }
        }
      });

      // Add click event handler for the SVG inside the accordion button
      $(accordion)
        .find(".plus-icon, .minus-icon")
        .on("click", (e) => {
          const accordionButton = $(e.target).closest(".accordion-button");
          accordionButton.click();
        });
    });
  };

  init();
};

try {
  contentAccordions();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
